import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LoadingComponent } from '@shared/ui-components/loading/loading.component';

@Component({
  selector: 'ac-loading-panel',
  standalone: true,
  imports: [LoadingComponent],
  template: '<ac-loading class="w-full" color="primary" />',
  styles: [
    `
      @use '/src/styles/colors';
      @use '/src/styles/functions';
      @use '/src/styles/z-index';
      :host {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(colors.$color-neutral-light, 0.7);
        padding: functions.spacing(1.5) functions.spacing(2);
        display: grid;
        place-items: center;
        z-index: z-index.$z-index-loading;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingPanelComponent {}
